// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_Oxh","cls2":"ExportFormatModal-cls2_m_T ExportFormatModal-cls1_Oxh"};